import { render, staticRenderFns } from "./MiraklAuth.vue?vue&type=template&id=fdc95084&scoped=true"
import script from "./MiraklAuth.vue?vue&type=script&lang=js"
export * from "./MiraklAuth.vue?vue&type=script&lang=js"
import style0 from "./MiraklAuth.vue?vue&type=style&index=0&id=fdc95084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc95084",
  null
  
)

export default component.exports